@use '../../../../app/styles/common/mixins';
@use '../../../../app/styles/common/colors';
@use '../../../../app/styles/common/variables';

.offerContent {
  padding: 0;
  background-color: var(--surface-00);

  @include mixins.laptop {
    background-color: var(--surface-01);
    padding: var(--spasing20) var(--spasing16) 0;
  }

  // The actions bar's bottom padding is the 12px above the crumbs; this padding is the 12px below
  .mobileBreadcrumbs {
    background-color: var(--surface-01);
    padding: 0 var(--spasing16) var(--spasing12);
  }

  .mobileOfferTop {
    background-color: var(--surface-01);

    // BP-8082: no top padding — the 12px gap above the row is the actions
    // bar's own bottom padding ($topActionsBarGapMobile). This 2-class selector
    // deterministically overrides `.offerTop`'s base `padding: 16px 0`.
    padding: 0 var(--spasing16) var(--spasing12);
  }

  .anchor {
    width: 100%;
    height: 0;
  }
}

.offerRow {
  display: flex;
  flex-direction: column;

  margin: 0;
  padding: 0;

  @include mixins.laptop {
    flex-direction: row;
  }
}

.offerColumn {
  display: flex;
  flex-direction: column;
  gap: var(--spasing04);
  padding: 0 0 var(--spasing06);
  width: 100%;

  &.leftColumn,
  &.rightColumn {
    padding: 0;
  }

  @include mixins.laptop {
    &.leftColumn {
      flex: 3 1 512px;
      min-width: 0;
      max-width: 620px;
      gap: 0;
    }

    &.rightColumn {
      flex: 5 1 480px;
      min-width: 0;
      max-width: none;
      padding-left: 40px;
    }
  }

  @include mixins.desktop {
    &.rightColumn {
      padding-left: 64px;
    }
  }
}

.sectionTitle {
  margin-bottom: var(--spasing16);
}

// BP-7491: offer-page section headings — 20px (heading/primary/400) below laptop,
// 24px (heading/primary/500) at laptop+. The element-qualified selector reaches
// specificity 0,1,1 so it beats the shared `.h2` rule deterministically.
// Typography only — the title→content margin stays on the plain `.sectionTitle` class.
h2.sectionTitle {
  @include mixins.heading-primary-400;

  @include mixins.laptop {
    @include mixins.heading-primary-500;
  }
}

.detailsTitle {
  margin-bottom: var(--spasing12);

  @include mixins.laptop {
    margin-bottom: var(--spasing16);
  }
}

// BP-7916: dashed rule between the features list and the description inside
// the merged "Детали объявления" section.
.detailsSeparator {
  margin: var(--spasing12) 0;
  border: none;
  border-top: 1px dashed var(--border-primary);

  @include mixins.laptop {
    margin: var(--spasing16) 0;
  }
}

.placeTitle {
  margin-bottom: var(--spasing12);

  @include mixins.laptop {
    margin-bottom: var(--spasing16);
  }
}

.section {
  padding: var(--spasing16);
  border-radius: var(--rounding16);
  background-color: var(--surface-01);

  @include mixins.desktop {
    padding: var(--spasing24) 0;
  }

  &.gallery {
    padding-top: 0;
    border-radius: 0 0 var(--spasing20) var(--spasing20);
  }

  &.similarItems {
    .sectionTitle {
      // The Feed grid adds 12px (mobile) / 16px (tablet+) of top padding above the
      // first card row (see Feed/feed.module.scss `.container` padding-top), so the
      // title margin is trimmed to land Figma's title→list gap (16px mobile/tablet,
      // 20px desktop) without double-counting that padding. Keep in sync if Feed changes.
      margin-bottom: var(--spasing04); // 4 + 12 = 16px visual

      @include mixins.tablet {
        margin-bottom: 0; // 0 + 16 = 16px visual
      }

      @include mixins.desktop {
        margin-bottom: var(--spasing04); // 4 + 16 = 20px visual
      }
    }
  }
}

.offerInfo {
  padding: 0;

  @include mixins.laptop {
    position: sticky;
    top: var(--spasing16);
  }
}
